
// Here we're assuming that the scrollbar width doesn't change during the
// session:
let cachedValue: number | undefined;

// https://davidwalsh.name/detect-scrollbar-width
const getMaxScrollbarWidth = (offscreenRenderingDivID: string) => {
  if (cachedValue === undefined) {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '100px';
    scrollDiv.style.height = '100px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';

    const offscreenRenderingDiv = document.getElementById(offscreenRenderingDivID);
    if (offscreenRenderingDiv === null) {
      throw new Error('Cannot find offscreen rendering div that has ID ' + offscreenRenderingDivID);
    }
    offscreenRenderingDiv.appendChild(scrollDiv);
    cachedValue = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    scrollDiv.remove();
    return cachedValue;
  } else {
    return cachedValue;
  }
};

export default getMaxScrollbarWidth;
